import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/ErrorBoundary';
import ClientLanding from './pages/ClientLanding';
import ClientAuth from './pages/ClientAuth';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DriverResetPassword from './pages/DriverResetPassword';
import ChangePassword from './pages/ChangePassword';
import ClientDashboard from './pages/ClientDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import DriverLogin from './pages/DriverLogin';
import DriverDashboard from './pages/DriverDashboard';
import AuthCallback from './pages/AuthCallback';
import ServiceDetailPage from './pages/ServiceDetailPage';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const isDev = process.env.NODE_ENV === 'development';

function App() {
  useEffect(() => {
    if (window.google?.maps?.places) return;
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) return;

    if (!window.google && GOOGLE_MAPS_API_KEY) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=es`;
      script.async = true;
      script.defer = true;
      script.onload = () => { if (isDev) console.debug('Google Maps API loaded'); };
      script.onerror = () => { if (isDev) console.warn('Google Maps API failed to load'); };
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<ClientLanding />} />
          <Route path="/login" element={<ClientAuth />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<ClientDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/servicio/:id" element={<ServiceDetailPage />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver/dashboard" element={<DriverDashboard />} />
          <Route path="/driver/reset-password" element={<DriverResetPassword />} />
          <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </ErrorBoundary>
    </div>
  );
}

export default App;
